<div class="SLV2-main-wrapper">
    
    <div class="SLV2-body-section">

        <div class="SLV2-section-wrap SLV2-page-header-area">
            <div class="SLV2-page-header-lft">
                <button class="SLV2-header-text-button">
                    <img (click)="navigateToPracticePage()" src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                    <span>{{title}}</span>
                </button>
            </div>
        </div>


        <div class="SLV2-section-wrap">

            <div class="row SLV2-sm-gap SLV2-leading-zero-list">
                <ng-container *ngFor="let topic of tabPracticeTopicData let i = index">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-6">
                        <app-practice-card [parcticeCardData]="topic"></app-practice-card>
                    </div>
                </ng-container>
            </div>

        </div>


    </div>
</div>

